/* eslint-disable react/no-string-refs */
/* eslint-disable react/prop-types */
import React, { PureComponent } from "react";
import Loading from "../loading";
import Cropper from "cropperjs";
import { Button, Row, Col } from "antd";
import * as THREE from "three";
import "./../../styles/photo-viewer.css";
import "cropperjs/dist/cropper.css";

// const cropper = React.createRef(null);

export default class PhotoViewerWrapper extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            imageLoaded: false,
            loading: false,
            started: false,
            onload: false,
            canvasData: null,
            cropBoxData: null,
            croppedData: null,
            cropper: null
        };
    }

    componentDidMount() {
        // spike on using promises and a different loader or adding three js loading manager
        const loader = new THREE.TextureLoader();
        loader.crossOrigin = "";
        // load a resource
        loader.load(
            // resource URL
            this.props.filePath,
            // Function when resource is   loaded
            (texture) => {
                this.setState({
                    originalWidth: texture.image.width,
                    originalHeight: texture.image.height,
                    imageLoaded: true,
                    texture,
                });
            },
            (xhr) => {
                console.log(`${xhr.loaded / xhr.total * 100}% loaded`);
            },
            (xhr) => {
                console.log("An error happened", xhr);
            },
        );
    }

    componentDidUpdate(prevProps) {
        if(prevProps.filePath !== this.props.filePath) {
            this.reset();
        }
        if(!this.state.started && this.props.filePath) {
            this.setState({
                started: true
            }, () => {
                this.start();
            });
        }
    }

    methods = (action) => {
        const { cropper } = this;
        switch (action) {
        case "move":
        case "crop":
            cropper.setDragMode(action);
            break;
        case "zoom-in":
            cropper.zoom(0.1);
            break;
        case "zoom-out":
            cropper.zoom(-0.1);
            break;
        case "rotate-left":
            cropper.rotate(-90);
            break;
        case "rotate-right":
            cropper.rotate(90);
            break;
        default:
            break;
        }
    }

    start = () => {
        const image = window.document.getElementById("image");
        if(image) {
            this.cropper = new Cropper(image, {
                autoCrop: false,
                dragMode: "move",
                background: false,
                ready: () => {
                    if(this.croppedData) {
                        this.cropper
                            .crop()
                            .setData(this.croppedData)
                            .setCanvasData(this.canvasData)
                            .setCropBoxData(this.setCropBoxData);
                        this.croppedData = null;
                        this.canvasData = null;
                        this.setCropBoxData = null;
                    } else {
                        this.cropper.zoom(-0.8);
                    }
                },
                crop: ({detail}) => {
                    if(detail.width > 0 && detail.height > 0 && !this.state.cropping) {
                        this.setState({
                            cropping: true
                        });
                    }
                }
            });
        }
    }

    stop = () => {
        if(this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
            this.start();
        }
    }

    crop = () => {
        const { cropper, state } = this;
        if(state.cropping) {
            this.croppedData = cropper.getData();
            this.canvasData = cropper.getCanvasData();
            this.setCropBoxData = cropper.getCropBoxData();
            this.setState({
                cropped: true,
                cropping: false,
                previousUrl: state.url,
                url: cropper.getCroppedCanvas({
                    fillColor: "#fff",
                }).toDataURL(state.type)
            });
            this.stop();
        }
    }

    clear = () => {
        if(this.state.cropping) {
            this.cropper.clear();
            this.setState({
                cropping: false
            });
        }
    }

    restore = () => {
        if(this.state.cropped) {
            this.setState({
                cropped: false,
                previousUrl: "",
                url: this.state.previousUrl
            });
        }
    }

    reset = () => {
        this.stop();
        this.setState({
            cropped: false,
            cropping: false,
            loaded: false,
            name: "",
            previousUrl: "",
            type: "",
            url: ""
        });
    }

    update = (data) => {
        Object.assign(this.state, data);
    }

    saveData = () => {
        this.cropper.getCroppedCanvas({
            imageSmoothingQuality: "high"
        }).toBlob((blob) => {
            this.props.createNewDocument(blob);
        });
    }

    render() {
        if (!this.state.imageLoaded) {
            return <Loading />;
        }
        console.log(this.croppedData);
        return (
            <React.Fragment>
                <Row>
                    <Col span={24}>
                        <div className={"toolbar"}>
                            <div>
                                <Button style={{border: "none"}} icon={"zoom-in"} onClick={this.methods.bind(null, "zoom-in")} />
                                <Button style={{border: "none"}} icon={"zoom-out"} onClick={this.methods.bind(null, "zoom-out")} />
                            </div>
                            <div>
                                <Button style={{border: "none"}} icon={"retweet"} onClick={this.methods.bind(null, "crop")} />
                                <Button style={{border: "none"}} icon={"close-circle"} onClick={this.reset} />
                                <Button onClick={() => this.saveData()} type={"link"}>Save</Button>
                                <Button style={{border: "none"}} icon={"drag"} onClick={this.methods.bind(null, "move")} />
                            </div>
                            <div>
                                <Button style={{border: "none"}} icon={"undo"} onClick={this.methods.bind(null, "rotate-left")} />
                                <Button style={{border: "none"}} icon={"redo"} onClick={this.methods.bind(null, "rotate-right")} />
                            </div>
                        </div>
                    </Col>
                    <Col span={24} className={"editor"}>
                        <div className={"canvas"}>
                            <img id={"image"} src={this.props.filePath} width={"80%"}/>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}
